import { render, staticRenderFns } from "./WhereToEatAndDrink.vue?vue&type=template&id=2e55a06c"
import script from "./WhereToEatAndDrink.vue?vue&type=script&lang=js"
export * from "./WhereToEatAndDrink.vue?vue&type=script&lang=js"
import style0 from "./WhereToEatAndDrink.vue?vue&type=style&index=0&id=2e55a06c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports